<div class="close">
  <button (click)="close()">
    <img
      alt="close"
      width="24"
      height="24"
      src="../../../assets/images/close.svg"
    />
  </button>
</div>
<div class="content">
  <div class="title">客服咨询</div>
  <div class="subtitle">扫描下方二维码</div>
  <div class="subtitle">咨询订单详情</div>
  <img
    src="../../../assets/images/customer_service_qrcode_new.png"
    [width]="250"
    height="auto"
    alt=""
  />
  <div class="subtitle">客服在线时间8:00-17:00</div>
  <div class="button" (click)="close()">确认</div>
</div>
